import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import CardPanduan from 'app/KinerjaShared/components/CardPanduan'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { PerencanaanPegawaiCard } from 'app/KinerjaPamongPage/components/perencanaan/PerencanaanPegawaiCard'
import { PelaksanaanPegawaiCard } from 'app/KinerjaPamongPage/components/perencanaan/PelaksanaanPegawaiCard'

export function Homepage() {
  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="pamong-pegawai" sticky />
      </div>
      <main className="w-full gap-4 p-6 space-y-6">
        <PerencanaanPegawaiCard />
        <PelaksanaanPegawaiCard />

        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Penetapan Predikat Kinerja'],
            },
          ]}
        />

        <CardPanduan />
      </main>
    </div>
  )
}
